"use strict";
Object.defineProperty(exports, "__esModule", { value: true });
exports.RowPrefix = void 0;
var RowPrefix;
(function (RowPrefix) {
    RowPrefix["Default"] = "defaultRow_";
    RowPrefix["Dynamic"] = "dynamicRow_";
})(RowPrefix = exports.RowPrefix || (exports.RowPrefix = {}));
//# sourceMappingURL=Tables.js.map